export const query = `
{
  queryVideosContents(top: 200) {
    flatData {
      contributor {
        flatData {
          name
          country
          geolocation
          bio
          gender {
            flatData {
              gender
            }
          }
          discipline {
            flatData {
              discipline
            }
          }
          generation {
            flatData {
              generation
            }
          }
        }
      }
      created
      question {
        flatData {
          question
          longQuestion
        }
      }
      topic
      video {
        url
      }
      videoStillImage {
        url
      }
    }
  }
  queryQuestionsContents {
    flatData {
      question
    }
  }
  queryGenerationsContents {
    flatData {
      generation
    }
  }
  queryDisciplinesContents {
    flatData {
      discipline
    }
  }
  queryGendersContents {
    flatData {
      gender
    }
  }
  queryTermsofuseContents {
    flatData {
      termsofuse
    }
  }
  queryAboutContents {
    flatData {
      abouttext
    }
  }
}
`;
